var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.classes,style:(_vm.background)},[(_vm.banner.hasOwnProperty('text'))?_c('div',{domProps:{"innerHTML":_vm._s(_vm.banner.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }